<script lang="ts" setup>
import type { OmniCheckboxProps } from "@/types/props";

defineOptions({ inheritAttrs: false });

const model = defineModel<boolean | unknown[]>({ default: false });

const props = withDefaults(defineProps<OmniCheckboxProps>(), {
  id: undefined,
  label: "",
  value: undefined,
  trueValue: undefined,
  falseValue: undefined,
  indeterminate: false,
  required: false,
  rules: () => [],
  disabled: false,
  readonly: false,
  color: "primary",
  density: "compact",
  hideDetails: true,
});
</script>

<template>
  <v-checkbox
    :id="props.id"
    v-model="model"
    :class="{ required: props.required }"
    :color="props.color"
    :density="props.density"
    :disabled="props.disabled"
    :false-value="props.falseValue"
    :hide-details="props.hideDetails"
    :indeterminate="props.indeterminate"
    :label="props.label"
    :readonly="props.readonly"
    :rules="props.rules"
    :true-value="props.trueValue"
    :value="props.value"
    class="omni-checkbox"
    v-bind="$attrs"
  >
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps ?? {}" />
    </template>
  </v-checkbox>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.omni-checkbox {
  &:deep(.v-selection-control) {
    gap: 8px;
  }

  &:deep(label) {
    color: $dark-grey;
    font-size: 14px;
  }
}
</style>
